<div class="multi-select-container form-control" [ngClass]="{'tig-disabled':getDisabled()}" [tigClickOutside]="clickedOutside" tabindex="0">
    <div class="selected" (click)="toggleOptions($event)">
        <span *ngIf="count==0" class="placeholder">{{getSettings()?.placeholder|translate}}</span>
        <span *ngFor="let item of getItems()">
            <ng-container *ngFor="let option of item?.options">
                <span class="item active" *ngIf="option?.checked">
                    <span class="option" [innerHtml]="option.label"></span>&nbsp;<i class="fa fa-remove" (click)="select(option)" *ngIf="!getDisabled() && !option.disabled"></i>
                </span>
            </ng-container>
        </span>
    </div>
    <div class="options-wrapper" [ngStyle]="{display:optionsOpened()?'block':'none'}" *ngIf="!getDisabled()">
        <div class="filter" *ngIf="getSettings()?.enableFilter">
            <input class="form-control ng-valid ng-dirty ng-touched" type="text" [value]="filterText" placeholder="{{getSettings()?.filterPlaceholder|translate}}" [formControl]="filterInput" autofocus />
            <i class="fa fa-remove" (click)="clearFilter()"></i>
            <div class="tig-spinner tig-spinner-fading-circle" [ngClass]="this.showSpinner?'show':''">
                <div class="tig-circle1 tig-circle"></div>
                <div class="tig-circle2 tig-circle"></div>
                <div class="tig-circle3 tig-circle"></div>
                <div class="tig-circle4 tig-circle"></div>
                <div class="tig-circle5 tig-circle"></div>
                <div class="tig-circle6 tig-circle"></div>
                <div class="tig-circle7 tig-circle"></div>
                <div class="tig-circle8 tig-circle"></div>
                <div class="tig-circle9 tig-circle"></div>
                <div class="tig-circle10 tig-circle"></div>
                <div class="tig-circle11 tig-circle"></div>
                <div class="tig-circle12 tig-circle"></div>
            </div>
        </div>
        <div class="options">
            <div *ngFor="let item of getItems()|tigMultiselectFilter:{text:filterText,id:filterText}:'options':isBackendSearch()">
                <div class="item" *ngIf="item?.options">
                    <div class="divider"></div>
                    <div class="header">{{item.text}}</div>
                    <div class="option" *ngFor="let option of item?.options">
                        <a [ngClass]="{'active':option?.checked, 'disabled':option?.disabled}" (click)="!option?.disabled?select(option):null">
                            <i class="fa fa-fw" [ngClass]="{'fa-check':option?.checked,'glyphicon-none':!option?.checked}"></i>
                            <span>{{option.text}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="hint" *ngIf="noResults">
                <div class="divider"></div>
                <div class="header">{{'sNoResults'|translate}}</div>
            </div>
        </div>
    </div>
</div>
